var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2942 2.84302C9.44285 2.84302 3.07849 9.20738 3.07849 17.0587C3.07849 24.91 9.44285 31.2744 17.2942 31.2744C25.1455 31.2744 31.5099 24.91 31.5099 17.0587C31.5099 9.20738 25.1455 2.84302 17.2942 2.84302Z",
    fill: "#1E5A64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2182 20.8268H22.8973L23.4751 17.0895H19.2182V15.0467C19.2182 13.4943 19.7257 12.1175 21.1779 12.1175H23.5114V8.85645C23.1012 8.80101 22.2341 8.68018 20.5957 8.68018C17.174 8.68018 15.1682 10.487 15.1682 14.6039V17.0902H11.6505V20.8275H15.1675V31.0997C15.864 31.2035 16.5698 31.2746 17.2941 31.2746C17.9488 31.2746 18.5878 31.2149 19.2182 31.1296V20.8268Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.84f03c00d7c026febc6bff9444b620bf.svg";
export { ForwardRef as ReactComponent };